import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaRegEye } from "react-icons/fa";
import { IoCreate } from "react-icons/io5";
import { Modal } from 'flowbite-react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../assest/images/37a39cb7092d94d7297953ad09f2dee5.png';

const PatientsAppointment = ({ onEditAppointments }) => {
  const [categories, setCategories] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [details, setDetails] = useState([]);
  const [error, setError] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [doctorId, setDoctorId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get('https://backend.amarasinghemedicare.com/category/doccategory')
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        setError(error.message);
      });
  }, []);

  const fetchDoctors = async (doctorId) => {
    try {
      const response = await fetch(`https://backend.amarasinghemedicare.com/doctors/doctor/${doctorId}`);

      if (!response.ok) {
        console.error("Error in frontend");
      }

      const data = await response.json();
      setDetails(data);
    } catch (error) {
      console.error("Something went wrong!");
    }
  }

  const fetchSchedules = async (doctorId) => {
    try {
      const response = await fetch(`https://backend.amarasinghemedicare.com/schedule/schedules?doctorId=${doctorId}`);
      const data = await response.json();

      if (response.ok) {
        setSchedules(data);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching schedules:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = (id) => {
    setDoctorId(id);
    setOpenModal(true)
    fetchDoctors(id);
    fetchSchedules(id);
  };

  const onCloseModal = () => {
    setOpenModal(false);
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#202643',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '13px',
      },
    },
  };

  const columns = [
    { name: 'Doctor ID', selector: row => row.id, sortable: true },
    { name: 'Doctor Name', selector: row => row.fullName, sortable: true },
    { name: 'Experience', selector: row => row.experience, sortable: true },
    { name: 'Contact', selector: row => row.contact_number },
    {
      name: '',
      cell: row => (
        <div className="flex space-x-3 justify-center items-center">
          <button onClick={() => handleOpenModal(row.id)} className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-blue text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            Create
            <IoCreate className='text-sm' />
          </button>

          <button onClick={() => onEditAppointments(row)} className="flex items-center justify-center align-middle font-semibold gap-1 p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1 outline-slate-500 bg-green text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
            View
            <FaRegEye className='text-sm' />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {error && <p>Error: {error}</p>}
      {categories.length === 0 ? (
        <p>Loading categories...</p>
      ) : (
        categories.map((category) => (
          <div key={category.id}>
            <h1 className='bg-[#4694C8] mt-6 w-fit p-1 rounded-sm text-gray-50 text-lg'>{category.eng_name}</h1>
            <DataTable
              columns={columns}
              data={category.Doctors}  // Use the doctors list from each category
              fixedHeader
              fixedHeaderScrollHeight="80vh"
              className="data-table"
              customStyles={customStyles}
              pagination
              paginationPerPage={20}
              paginationRowsPerPageOptions={[20]}
            />
          </div>
        ))
      )}

      <Modal show={openModal} size='6xl' onClose={onCloseModal} popup>
        <Modal.Header className='bg-fontDark' />
        <Modal.Body className='bg-gray-300'>
          <div className='flex flex-col sm:flex-col md:flex-row'>
            <div className='mb-10 px-0 sm:px-7 md:px-7 sm:w-full md:w-[23%] w-full'>
              <div className='p-5 bg-white flex flex-col items-center justify-center rounded-lg shadow-md gap-4'>
                <img className='w-32 h-32 sm:w-42 sm:h-42 md:w-52 md:h-40 rounded-full object-cover border border-fontDark'
                  src={
                    details?.profileImage
                      ? `https://backend.amarasinghemedicare.com/${details.profileImage.replace(/\\/g, '/')}`
                      : require('../../assest/images/Doctor.png') // Or use a public path if needed
                  } alt="" />

                <div className='flex flex-col items-center justify-center'>
                  <h1 className='text-base font-semibold text-fontDark'>{details.fullName}</h1>
                  <h3 className='text-sm'>-{details.qualifications}-</h3>
                </div>

                <button
                  className='flex items-center justify-center text-sm text-white uppercase font-light text-left bg-[#97CE4F] py-2 w-[100%] rounded-lg transform transition-transform duration-300 hover:scale-105'
                  onClick={() => navigate(`/details?doctorId=${doctorId}`, { state: details })}
                >
                  View Profile
                </button>
              </div>
            </div>

            <div className='bg-white my-2 sm:my-5 md:my-0 w-full sm:w-full md:w-[77%] rounded-lg shadow-md pb-7'>

              {isLoading ? (
                <p>Loading schedules...</p>
              ) : Array.isArray(schedules) && schedules.length > 0 ? (
                schedules.map((schedule) => {
                  const dataObj = new Date(schedule.date);
                  const options = { year: 'numeric', month: 'long', day: 'numeric' };
                  const formattedDate = dataObj.toLocaleDateString(undefined, options); // Format without weekday
                  const weekday = dataObj.toLocaleDateString(undefined, { weekday: 'long' }); // Only weekday name

                  return (
                    <>
                      <div key={schedule.id} className="mt-7 px-7 ">
                        <h1>{weekday}, {formattedDate}</h1>
                        <div className="flex items-center justify-between mt-2 rounded-lg shadow-lg p-2 bg-white border-l-8 border-green">
                          <img src={Logo} alt="" className="w-[7%] pl-2 shadow-md p-2 rounded-lg" />

                          <div className="ml-2">
                            <h1 className="text-xs font-semibold">Amarasingha Medicare</h1>
                            <h1 className="text-xs font-extralight">Colombo</h1>
                          </div>

                          <div className="flex sm:flex-row md:flex-row flex-col gap-4 sm:gap-0 md:gap-0 w-[80%] items-center justify-around">
                            <div className="flex flex-col items-center justify-center">
                              <h1 className="text-xs font-semibold text-blue">{schedule.start_time}</h1>
                              <h1 className="text-xs font-extralight">Starting</h1>
                            </div>

                            <div className="flex flex-col items-center justify-center">
                              <h1 className="text-xs font-semibold text-red">{schedule.end_time}</h1>
                              <h1 className="text-xs font-extralight">Ending</h1>
                            </div>

                            <div>
                              <h1 className="text-xs font-semibold text-green">Rs {schedule.doctor_fee} + Booking Fee</h1>
                              <h1 className="text-xs font-extralight">Fee</h1>
                            </div>

                            <div className="flex flex-col items-center justify-center">
                              <h1 className="text-xs font-semibold text-red">{schedule.bookedPatients}</h1>
                              <h1 className="text-xs font-extralight">Appointments</h1>
                            </div>

                            <div className='flex flex-col gap-2'>
                              <Link to={`/bookingform?scheduleID=${schedule.id}`}>
                                <h1 className="text-xs text-white uppercase text-left bg-[#97CE4F] py-2 px-14 rounded-lg transform transition-transform duration-300 hover:scale-105">Book</h1>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })
              ) : (
                <p className='p-10'>No schedules available.</p>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PatientsAppointment;